<template>
<body>
  <!-- <lottie-animation
    path="../../../assets/398-snap-loader-white.json"
/> -->
  <div v-bind:class="{ burgerMenuContainer: true, active: showNav }">
    <div @click="mixNav()" class="burgerHeader">
      <a href="#" class="closeMenu"><i class="far fa-times"></i></a>
    </div>
    <div class="burgerBody">
      <nav>
        <ul class="topMenu">
          <li>
            <a href="/#/index" target="_self">
              Home
            </a>
          </li>
          <li>
            <router-link to="/shop" target="_self">
              Shop
            </router-link>
          </li>
          <li class="active">
            <router-link to="/user/account" target="_self">
              Account
            </router-link>
          </li>
          <li class="">
            <router-link to="/how-it-works" target="_self">
              How It Works
            </router-link>
          </li>
        </ul>
      </nav>
    </div>
    <div class="burgerBot">
      <p>supremeaccess | Legal | Disclousure</p>
    </div>
  </div>
  <div class="flexLayoutShop">
    <div class="leftSidebar">
      <div class="logoContainer">
        <a href="/#/"><img src="../../../assets/images/logo-white.svg" alt="" /></a>
      </div>
      <section class="sidebarBot">
        <div class="sideBotBod">
          <div class="sideBotFlexMenu">
            <li><a href="/#/index">Home</a></li>
            <li>
              <router-link to="/shop">Shop</router-link>
            </li>
            <li class="active">
              <router-link to="/user/account">Account</router-link>
            </li>
            <!-- <li class="">
              <router-link to="/how-it-works">Help</router-link>
            </li> -->
          </div>
          <div class="sidePageTitle">
            <h1>Account</h1>
          </div>
        </div>
      </section>
    </div>
    <div class="flexLayoutBody">
      <!-- <span class="pageTitleOnMobile">Account</span> -->
      <div class="mobileNavTop">
        <a @click="mixNav" href="#" class="iconBarsMobile"><i class="fas fa-bars"></i></a>
        <div class="logoContainerMobile">
          <a href="/#/index"><img src="../../../assets/images/logo-white.svg" alt="" /></a>
        </div>
        <a href="#" class="iconCartMobile openSidebar"><img src="../../../assets/images/icon-cart.svg" alt="" /></a>
      </div>
      <div class="flexLayoutTop">
        <div class="flexLayoutShopFilter">
          <nav class="flexLayoutShopFilterActual">
            <li class="active">
              <router-link to="/user/account">Account Info</router-link>
            </li>
            <li>
              <router-link to="/user/profiles">Profiles</router-link>
            </li>
            <li>
              <router-link to="/user/orders">Orders</router-link>
            </li>
            <li>
              <router-link to="/logout">Sign Out</router-link>
            </li>
          </nav>
        </div>
        <div class="flexLayoutTopRight">
          <a href="#" class="openSidebar"><img src="../../../assets/images/icon-cart.svg" alt="" /></a>
        </div>
      </div>
      <div class="flexLayoutActualBody">
        <div class="userInfoInAccountContainer">
          <div class="itemBodyLeftModal notModal">
            <div class="dualInputContainerForm">
              <div class="inputsContainer">
                <h2>User Details</h2>
                <div class="individualInput">
                  <h5>Name</h5>
                  <input v-model="userInfo.name" type="text" name="" id="" v-bind:placeholder="name || 'Your Name'" v-bind:disabled="editing == false" />
                </div>
                <!--<div class="individualInput">
                  <h5>Full Name</h5>
                  <input type="text" name="" id="" placeholder="WHAT THE FUCK IS THIS SHIT" />
                </div> -->
                <div class="individualInput">
                  <h5>Phone Number</h5>
                  <input v-model="userInfo.phone" type="text" name="" id="" v-bind:placeholder="phone || 'Your Phone'" v-bind:disabled="editing == false" />
                </div>
                <div class="individualInput">
                  <h5>Email</h5>
                  <input v-model="userInfo.email" type="text" name="" id="" v-bind:placeholder="email || 'Your Email'" v-bind:disabled="editing == false" />
                </div>
              </div>
              <div class="inputsContainer">
                <h2>Payment/Billing</h2>
                <div class="individualInput">
                  <h5>Address</h5>
                  <input v-model="userInfo.billingAddress.line1" type="text" name="" id="" v-bind:placeholder="address1 || '123 Cherry Ave'" v-bind:disabled="editing == false" />
                </div>
                <div class="individualInput">
                  <h5>City</h5>
                  <input v-model="userInfo.billingAddress.city" type="text" v-bind:placeholder="city || 'New York'" v-bind:disabled="editing == false" />
                </div>
                <div v-if="userInfo.billingAddress.country == 'US'" class="individualInput">
                  <h5>State</h5>
                  <select v-model="userInfo.billingAddress.state" v-bind:selected="state" v-bind:disabled="editing == false">
                    <option v-for="(state,key) in states" :value="key">{{state}}</option>
                    <!--<option value="volvo">Select One</option>
                    <option value="saab">Select One</option>
                    <option value="mercedes">Select One</option>
                    <option value="audi">Select One</option> -->
                  </select>
                </div>

                <div v-if="userInfo.billingAddress.country != 'US'" class="individualInput">
                  <h5>State</h5>
                  <input :disabled="editing == false" v-model="userInfo.billingAddress.state" placeholder="State">
                </div>
                <div class="individualInput">
                  <h5>Zip Code</h5>
                  <input v-model="userInfo.billingAddress.postal_code" type="text" name="" id="" v-bind:placeholder="zip || '10001'" v-bind:disabled="editing == false" />
                </div>
                <div class="individualInput">
                  <h5>Credit Card</h5>
                  <div class="ccSaved">
                    <!-- <h6>Visa</h6> -->
                    <p>**** **** **** {{userInfo.billingLast4}}</p>
                    <!-- <p>4432 2293 8834 7743</p> -->
                    <a @click="changeCard" class="changeCard">Change</a>
                  </div>
                </div>
              </div>
            </div>
            <div class="quickCheckout">
              <a v-if="editing == true" @click="saveProfile" href="#">Save</a>
              <a v-if="editing == false" @click="editInfo" href="#">Edit</a>
              <small>
                <!-- Mauris eros mauris, aliquam ut elementum ut, interdum eu arcu.
                Praesent sodales lacus vitae orci pellentesque, non iaculis
                eros vehicula. Nullam auctor et arcu quis aliquet. Vestibulum
                ante ipsum primis in. -->
              </small>
            </div>
          </div>
          <!-- card modal -->

          <div v-if="editingCard" class="modalContainer active loginModal formsModal">
            <div class="actualModal">
              <a @click="changeCard" href="#" class="closeModal"><i class="fal fa-times"></i></a>
              <div class="modalBodyOfItem">
                <div class="itemBodyLeftModal">
                  <h4>Credit Card Info</h4>
                  <div class="inputsContainer">
                    <div class="individualInput">
                      <h5>Full Name</h5>
                      <input v-model="card.name" type="text" name="" id="" placeholder="John Doe" />
                    </div>
                    <div class="individualInput">
                      <h5>Credit Card Number</h5>
                      <input maxlength="16" v-model="card.number" type="text" name="" id="" placeholder="Enter Card Number" />
                    </div>
                    <div class="dualInputContainer">
                      <div class="individualInput">
                        <h5>Expiration Date</h5>
                        <input maxlength="5" v-model="expdate" type="text" name="" id="" placeholder="00/00" />
                      </div>
                      <div class="individualInput">
                        <h5>Security Code</h5>
                        <input maxlength="4" v-model="card.code" type="text" name="" id="" placeholder="000" />
                      </div>
                    </div>
                  </div>
                  <div class="quickCheckout">
                    <div style="margin-bottom: 5px;" v-if="haserrors" class="error">Please double check your information.</div>
                    <a @click="saveCard" href="#">Save Card</a>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <!-- ./ card modal -->
        </div> <!-- flex body -->
      </div>
    </div>
  </div>
</body>
</template>
<script>
import { setupService } from '@/services/setup'
import states from '@/helpers/states'
import { userService } from '@/services/user'
export default {
  data() {
    return {
      haserrors: false,
      expdate: null,
      editingCard: false,
      card: {
        name: null,
        number: null,
        month: null,
        year: null,
      },
      email: null,
      name: null,
      city: null,
      address1: null,
      address2: null,
      state: null,
      zip: null,
      phone: null,
      states,
      editing: false,
      showNav: false,
      stripeToken: null,
      userInfo: {
        billingAddress: {

        }
      },
    }
  },
  created() {
    // this.$store.dispatch('auth/fetchUser')
    userService.userInfo()
      .then((resp) => {
        this.userInfo = resp

      })

  },
  methods: {
    async createToken() {
      let { card } = this
      let cardData = {
        card: {
          name: card.name,
          number: card.number,
          exp_month: card.month,
          exp_year: card.year,
          cvc: card.code,
          address_zip: this.userInfo.billingAddress.postal_code
        },
      }
      console.log(`creating stripe token with data`, cardData)
      let token = await setupService.getStripeToken(cardData)
      console.log(`got token`, token)
      return token
    },
    async saveCard() {
      let month = this.expdate.split('/')[0]
      let year = this.expdate.split('/')[1]
      this.card.month = month
      this.card.year = year
      let { card } = this
      let isPrivacy = card.number.toString().startsWith('4767') || card.number.toString().startsWith('4859')
      if (!card.name || !card.code || !card.number || !this.card.year || !this.card.month || isPrivacy) return this.haserrors = true
      let token = await this.createToken()
      this.stripeToken = token.id
      this.saveProfile(true)
      this.editingCard = false

    },
    saveProfile(withCard) {
      console.log('what the fuck is going on here');
      // if (withCard && !this.stripeToken) return this.haserrors = true

      // save info
      let data = {
        billingAddress: this.userInfo.billingAddress
      }
      if (this.stripeToken) data.token = this.stripeToken

      setupService.setBilling(data)
        .then((resp) => {
          console.log(`set billing response`, resp)
          this.$store.dispatch('auth/fetchUser')
        })
      // console.log('fuck loll')
      userService.updateProfile({ name: this.userInfo.name, phone: this.userInfo.phone, email: this.userInfo.email })
        .then((res) => {
          console.log(`update profile resp`, res)
          this.$store.dispatch('auth/fetchUser')
        })
      this.editing = false;
    },
    changeCard() {
      console.log(`card change button clicked`)
      this.editingCard = !this.editingCard
    },
    editInfo() {
      this.editing = true;
    },
    mixNav() {
      console.log("Mix Nav called")
      this.showNav = !this.showNav;
    }
  }
}
</script>
